import { cloneDeep } from '@lsfe/tools';

export default {
    alertWithNoOperation(msg, title, option) {
        const noOperations = { closeOnPressEscape: false, showClose: false, closeOnClickModal: false };
        return this.$alert(msg, title, { ...option, ...noOperations });
    },
    generateId() {
        let d = +new Date();
        const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            // eslint-disable-next-line no-bitwise
            const r = ((d + Math.random() * 16) % 16) | 0;
            d = Math.floor(d / 16);
            // eslint-disable-next-line no-mixed-operators,no-bitwise
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },

    // 替换数据中的默认数据
    replaceDefaultData(data, key, defaultVal, replace = '') {
        const keys = Array.isArray(key) ? key : [key];
        keys.forEach((v) => {
        data[v] = data[v] == defaultVal ? cloneDeep(replace) : data[v]; // eslint-disable-line
        });
    },
};
